/**
 * Friendly fallback rendered when a `<RoleGate>` denies access. Use as
 * the `fallback` prop on full-page gates so a non-admin who navigates
 * to `/admin` lands on a clear "this area is for administrators" notice
 * instead of a broken UI or a blank page.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';

export function NotAuthorized({
  title = 'Not available for your role',
  description = "Your account doesn't have access to this area. If you think that's wrong, ask an administrator to update your role.",
  backHref = '/dashboard',
  backLabel = 'Back to dashboard',
}) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4" data-testid="not-authorized">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-4 py-10 text-center">
          <div className="rounded-full bg-muted p-3">
            <ShieldAlert className="h-8 w-8 text-muted-foreground" />
          </div>
          <div className="space-y-1">
            <h2 className="text-lg font-semibold">{title}</h2>
            <p className="text-sm text-muted-foreground max-w-sm">{description}</p>
          </div>
          <Link to={backHref}>
            <Button variant="outline" data-testid="not-authorized-back">
              {backLabel}
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}

export default NotAuthorized;
